import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// CSRF double-submit — read the readable `csrf_token` cookie set by the backend
// on login/refresh and echo it back on any state-changing request. See
// backend/app/csrf.py for the server side.
function readCookie(name) {
  const m = document.cookie.match(new RegExp("(^|; )" + name.replace(/[$-.]/g, "\\$&") + "=([^;]*)"));
  return m ? decodeURIComponent(m[2]) : null;
}
const CSRF_UNSAFE = new Set(["post", "put", "patch", "delete"]);
api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (CSRF_UNSAFE.has(method)) {
    const token = readCookie("csrf_token");
    if (token) {
      config.headers = { ...(config.headers || {}), "X-CSRF-Token": token };
    }
  }
  return config;
});

let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    if (status === 401 && !original._retry && !String(original.url || "").includes("/auth/")) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" · ");
  }
  if (detail && typeof detail === "object") {
    if (typeof detail.msg === "string") return detail.msg;
    return JSON.stringify(detail);
  }
  return String(detail);
}
